import { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import AuthLayout from '../components/AuthLayout';
import PasswordInput from '../components/PasswordInput';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState('');
  const [msg, setMsg] = useState<string | null>(null);
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const userId = params.get('uid') || '';

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setMsg(null);
    const res = await fetch('/api/auth/reset', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token, userId, password }) });
    if (res.ok) {
      setMsg('Password updated. Redirecting to login...');
      setTimeout(() => navigate('/'), 1200);
    } else {
      setMsg('Reset failed. Link may be invalid or expired.');
    }
  }

  return (
    <AuthLayout title="Reset password">
      <form className="space-y-4" onSubmit={submit}>
        <div className="grid gap-2">
          <Label htmlFor="password">New password</Label>
          <PasswordInput id="password" value={password} onChange={e => setPassword(e.target.value)} required />
        </div>
        <Button type="submit" className="w-full">Update password</Button>
      </form>
      <div className="mt-3 text-right">
        <a href="/" className="text-sm text-primary underline-offset-4 hover:underline">Back to sign in</a>
      </div>
      {msg && <p className="mt-4 text-sm text-muted-foreground">{msg}</p>}
    </AuthLayout>
  );
}

